import React, { Fragment } from 'react'
import styles from './NavPanel.module.sass'
import { MenuItemType } from '@utils/types'
import { Button, WContainer, WLink } from '@components/atoms'
import { NavCard } from '@components/molecules'
import { ArrowRight } from '@components/icons'
//import { trackingGAevent, uniformData } from '@utils/gtm'

interface Props {
  item?: MenuItemType
  className?: string
}

const NavPanel = (props: Props) => {
  const { item = undefined, className = '' } = props

  const handleClickMenu = (label: string, position: string, type: string) => {
    // trackingGAevent('menu', {
    //   searchTerm: '',
    //   position: uniformData(position),
    //   label: uniformData(label),
    //   product: '',
    //   method: '',
    //   type: uniformData(type),
    // })
  }

  return item ? (
    <div className={`${styles.root} ${className}`} key={item.pk}>
      {item.children?.slice(0, 3)?.map((c1) => (
        <div key={c1.pk} className={`${styles.area} ${c1.key ? styles[`area--${c1.key}`] : ''}`}>
          <WContainer>
            {c1.key === 'prodotti-main' ? (
              <div className={styles.cols}>
                {c1.children?.map(
                  (c2) =>
                    c2.children?.length > 0 && (
                      <div
                        key={c2.pk}
                        className={`${styles.col} ${
                          c2.children.length > 10 ? styles['col--2cols'] : ''
                        }`}
                      >
                        {c2.name && <p className={styles.title}>{c2.name}</p>}
                        <ul
                          role="menu"
                          className={`${styles.colMenu} ${
                            c2.style ? styles[`colMenu--${c2.key}`] : ''
                          }`}
                        >
                          {c2.children?.map((c3) => (
                            <li key={c3.pk} className={styles.colItem} role="menuitem">
                              <WLink
                                href={c3.url}
                                newPage={c3.blank}
                                onClick={() => {
                                  handleClickMenu(
                                    `${item.name}^${c3.name}`,
                                    'second_level_menu',
                                    c3.name
                                  )
                                }}
                              >
                                {c2.style === 'colors' && c3.style && (
                                  <span
                                    className={styles.colItemColor}
                                    style={{ backgroundColor: c3.style }}
                                  />
                                )}
                                <span className={styles.colItemLabel}>{c3.name}</span>
                              </WLink>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )
                )}
              </div>
            ) : c1.key === 'prodotti-all' ? (
              <div className={styles.all}>
                <ul role="menu">
                  <li role="menuitem">
                    <Button label={c1.name} href={c1.url} icon={<ArrowRight />} iconPos="right" />
                  </li>
                </ul>
              </div>
            ) : c1.key === 'prodotti-evidenza' && c1?.children?.length ? ( // cards
              <div className={styles.evidenza}>
                <p className={styles.title}>{c1.name}</p>
                <ul role="menu" className={styles.evidenzaMenu}>
                  {c1.children?.map((c2) => (
                    <li key={c2.pk} role="menuitem">
                      <NavCard
                        item={c2}
                        onClick={() =>
                          handleClickMenu(`${item.name}^${c2.name}`, 'second_level_menu', c1.name)
                        }
                      />
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <></>
            )}
          </WContainer>
        </div>
      ))}
    </div>
  ) : (
    <></>
  )
}

export default NavPanel
